import { errorAlert } from "../actions/alert.js";
import { logout } from "../actions/auth.js";

export const auth = {
  FETCH_SUCCESS: "FETCH_SUCCESS",
  FETCH_FAILURE: "FETCH_FAILURE",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  UPDATE: "UPDATE",
  LOGOUT: "LOGOUT",
};

export const alertActions = {
  SHOW: "SHOW",
  HIDE: "HIDE",
  ERROR: "ERROR",
  SHOW_SUCCESS: "SHOW_SUCCESS",
};
export const tabActions = {
  NOT_CLICKED: "NOT_CLICKED",
  CLICKED: "CLICKED",
};

export const projects = {
  LIST: "LIST",
};
export const appraisalUserAction = {
  SET_USER_DATA: "SET_USER_DATA",
};
export function handleAxiosError(error, dispatch) {
  const res = error.response?.data;
  if (dispatch) {
    if (error.response.status === 403) {
      dispatch(logout());
      dispatch(errorAlert("Session expired please login again."));
    } else {
      dispatch(errorAlert(res?.error || error.message));
    }
  } else {
    alert(res?.error || error.message);
  }
}
